/**
 * Authentication related constants
 */
export const AUTH_CONSTANTS = {
  // Cookie configurations
  COOKIE_NAMES: {
    USER_DETAILS: 'UserDetails'
  },
  COOKIE_EXPIRY_DAYS: {
    USER_SESSION: 30
  },

  // Token storage keys
  STORAGE_KEYS: {
    API_TOKEN: 'APIKeyCMS',
    API_TOKEN_EXPIRY: 'APIKeyCMS_EXPIRY',
    USER_PROFILE: 'userProfile',
    AUTH_STATE: 'authState'
  },

  // Timing configurations
  TIMEOUTS: {
    AUTH_CHECK: 15000, // 15 seconds
    PROFILE_LOAD_DELAY: 300, // 300ms
    WELCOME_MESSAGE_DURATION: 2000, // 2 seconds
    SETUP_DELAY: 500, // 500ms
    EXTENDED_WELCOME_DURATION: 2500, // 2.5 seconds
    ERROR_MESSAGE_DELAY: 1500, // 1.5 seconds
    NETWORK_RETRY_DELAY: 2000, // 2 seconds
    FINAL_SETUP_DELAY: 800, // 800ms
    REDIRECT_MESSAGE_DELAY: 800 // 800ms
  },

  // Loading messages
  MESSAGES: {
    VERIFYING_ACCESS: 'Verifying access...',
    PROCESSING_SIGNIN: 'Processing sign-in...',
    COMPLETING_SIGNIN: 'Completing sign-in...',
    LOADING_PROFILE: 'Loading your profile...',
    SETTING_UP_WORKSPACE: 'Setting up your workspace...',
    ALMOST_READY: 'Almost ready...',
    PREPARING_DASHBOARD: 'Preparing your dashboard...',
    LOADING_APPLICATION: 'Loading application...',
    REDIRECTING_SIGNIN: 'Redirecting to Syngenta sign-in...',
    WELCOME_BACK: 'Welcome back! Preparing your workspace...',
    FINALIZING_SETUP: 'Finalizing setup...',
    NETWORK_ERROR: 'Network error. Retrying...',
    AUTH_ERROR: 'Authentication error. Redirecting...',
    AUTH_FAILED: 'Authentication failed. Redirecting to sign-in...',
    AUTH_TIMEOUT: 'Authentication timeout. Redirecting...'
  },

  // Route patterns
  ROUTES: {
    LOGIN_CALLBACK: '/login/callback',
    ROOT: '/',
    HOME: '/',
    ADMIN_HOME: '/admin-home'
  },

  // Token expiry (in hours)
  TOKEN_EXPIRY_HOURS: 24,

  // Error types
  ERROR_TYPES: {
    NETWORK: 'network',
    FETCH: 'fetch'
  }
} as const;
